import React, { Component } from "react";
import Render from "../../../components/Renderer";
import { Divider, message } from "antd";
import validatejs from "validate.js";
import { Constraints } from "./Constraints";
import { connect } from "react-redux";
import { getCounterCheckIn, getTerminal } from "../../../redux/actions/dropdown";
import { insertCounterCheckIn, updateCounterCheckIn } from "../../../redux/actions/setting";

class CounterCheckInEdit extends Component {
  state = {
    form: {},
    disabledSave: false,
    filterTerminal: [],
    filterAirline: [],
  };

  componentDidMount() {
    const { selected, params } = this.props;
    let { form } = this.state;
    form = { ...selected, ...form, ...params };
    this.setState({ form, errors: validatejs(form, Constraints) });
    this.setFilterTerminalAndAirline();
  }
  setFilterTerminalAndAirline = async () => {
    this.props.getTerminal().then(res => {
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        let data = res.payload.data.data;
        this.setState({
          filterTerminal: data
        });
      }
    });
  };
  onChange = ({ name, value, error }) => {
    let { form, errors } = this.state;
    form[name] = value;
    if (errors === undefined) errors = {};
    if (error === undefined) delete errors[name];
    else errors[name] = error.join();
    if (Object.keys(errors).length === 0) errors = undefined;
    this.setState({ form, errors });
  };

  renderInput = (name, text, index) => {
    var template = {
      type: "input",
      name: name,
      value: text,
      placeholder: ""
    };
    return Render(template, ({ name, value }) =>
      this.onChangeTable(index, name, value)
    );
  };

  onSave = () => {
    this.setState({ disabledSave: true }, () => {
      const { form } = this.state;
      const { selected } = this.props;
      if (selected) {
        // update
        const body = {
          counterId: form.counterId,
          airportId: form.airportId,
          terminalId: form.terminalId,
          counterNameEN: form.counterEN,
          counterNameTH: form.counterTH,
          remark: form.remark,
          isEnable: form.display ? 1 : 0,
          flightScope: form.flightScope,
          airlines: form.airlines
        };
        this.props.updateCounterCheckIn(body).then(res => {
          setTimeout(() => {
            this.setState({ disabledSave: false });
          }, 500);
          if (res.status === 400) {
            return message.error("ไม่สามารถเพิ่มหรือแก้ไขข้อมูลได้");
          } else if (
            res &&
            res.payload.status === 200 &&
            res.type.endsWith("SUCCESS")
          ) {
            message.success("Update Counter Check-In success");
            this.props.onRefresh(this.props.name);
            // this.props.getCounterCheckIn();
          }
        });
      } else {
        const body = {
          airportId: form.airportId,
          terminalId: form.terminalId,
          listCounterCheckIn: [
            {
              counterNameEN: form.counterEN,
              counterNameTH: form.counterTH,
              remark: form.remark,
              isEnable: form.display ? 1 : 0,
              flightScope: form.flightScope,
              airlines: form.airlines,
            }
          ]
        };
        this.props.insertCounterCheckIn(body).then(res => {
          setTimeout(() => {
            this.setState({ disabledSave: false });
          }, 500);
          if (res.status === 400) {
            message.error("ไม่สามารถเพิ่มหรือแก้ไขข้อมูลได้");
          } else if (
            res &&
            res.payload.status === 200 &&
            res.type.endsWith("SUCCESS")
          ) {
            message.success("Insert Counter Check-In success");
            this.props.onRefresh(this.props.name);
          }
        });
      }
    });
  };

  render() {
    const { params, selected } = this.props;
    const { form, errors, disabledSave, filterTerminal } = this.state;
    const template = [
      {
        type: "select",
        name: "airportId",
        label: "Airport",
        constraint: Constraints,
        value: form.airportId,
        disabled: params !== undefined || selected,
        placeholder: "Select Airport...",
        options: {
          name: "airportDOAOptions",
          id: "airportID",
          text: "airportName"
        }
      },
      {
        type: "select",
        name: "terminalId",
        constraint: Constraints,
        disabled: selected !== null,
        label: "Terminal",
        value: form.terminalId,
        placeholder: "Select Terminal...",
        options: {
          name: "terminalOptions",
          id: "terminalId",
          text: "terminalName",
          dataLoad: 1,
          dataService: filterTerminal,
          preFilter: x => x.airportId === form.airportId
        }
      },
      {
        type: "select",
        name: "flightScope",
        label: "Flight Scope",
        constraint: Constraints,
        value: form.flightScope,
        options: {
          name: 'flightScope',
          id: 'id',
          text: 'label',
          dataLoad: 1,
          dataService: [
            { id: 'domestic', label: 'Domestic' },
            { id: 'inter', label: 'Inter' },
            { id: 'both', label: 'Both' },
          ]
        }
      },
      {
        type: "select",
        name: "airlines",
        label: "Airlines",
        constraint: Constraints,
        multiple: true,
        value: form.airlines,
        options: {
          name: "airlineOptions",
          id: "airlineID",
          text: "showFilter"
        }
      },
      {
        type: "input",
        name: "counterEN",
        label: "Counter Name",
        constraint: Constraints,
        value: form.counterEN,
        addonAfter: "EN",
        placeholder: ""
      },
      {
        type: "input",
        name: "counterTH",
        constraint: Constraints,
        value: form.counterTH,
        addonAfter: "TH",
        placeholder: ""
      },
      {
        type: "switch",
        name: "display",
        label: "Display (On/Off)",
        value: form.display
      },
      {
        type: "textarea",
        name: "remark",
        label: "Remark",
        placeholder: "remark",
        constraint: Constraints,
        value: form.remark
      }
    ];
    return (
      <div className="card card-body card-body-component">
        {template.map((data, i) => {
          return (
            <div key={i} className="form-row form-inline mb-2 col-12 px-0">
              <label className="col-lg-2 col-md-3 col-sm-4 col-5 justify-content-end">
                {data.label && data.label + " : "}
              </label>
              <div className="col-lg-4 col-md-6 col-sm-8 col-12">
                {Render(data, this.onChange)}
              </div>
            </div>
          );
        })}
        <Divider />
        {/* footer */}
        <div className="text-center mt-2">
          <button
            onClick={() => this.props.onClose(this.props.name)}
            className="btn btn-light mr-2"
          >
            Cancel
          </button>
          <button
            disabled={errors !== undefined || disabledSave}
            onClick={this.onSave}
            className="btn btn-success mr-2"
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  language: state.language,
  airlineOptions: state.airlineOptions,
});

const mapDispatchToProps = dispatch => ({
  insertCounterCheckIn: body => dispatch(insertCounterCheckIn(body)),
  updateCounterCheckIn: body => dispatch(updateCounterCheckIn(body)),
  getCounterCheckIn: () => dispatch(getCounterCheckIn()),
  getTerminal: () => dispatch(getTerminal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CounterCheckInEdit);
